import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import { CebeViewModel } from 'src/app/_core/models/centros/cebe.model';
import { CentroProcedure } from 'src/app/_core/models/centros/centro-procedure.model';
import { CentrosService } from 'src/app/_core/providers/centros.service';
import { SettingsService } from 'src/app/_core/providers/settings.service';

@Component({
  selector: 'app-lista-centros-card',
  templateUrl: './lista-centros-card.component.html',
  styleUrls: ['./lista-centros-card.component.scss']
})
export class ListaCentrosCardComponent implements OnInit {


  @Input() centros!: CentroProcedure[];
  @Input() cebe: CebeViewModel;
  isAdmin: boolean = false;


  constructor(private readonly router: Router,
    private readonly _settingsService: SettingsService,
    private readonly _centrosService: CentrosService,) { }

  ngOnInit(): void {
    this._settingsService.isAdmin().subscribe((result) => {
      this.isAdmin = result;
    });
  }

  redirigirDetalle(centro: CentroProcedure): void {
    // Define la lógica de redirección al detalle del centro
    this.router.navigate(['/centro/', centro.id]);
  }

  goToCreateCentro() {
    this.router.navigate(['/centro/create/', this.cebe?.id]);
  }

  exportToExcel(event: Event, centroId: number) {
    event.stopPropagation();
    this._centrosService.exportToExcel(centroId)
      .pipe(
        catchError(error => {
          console.error('Error exporting to Excel', error);
          throw error;
        })
      )
      .subscribe(response => {
        this.saveFile(response, centroId);
      });
  }

  private saveFile(response: Blob, centroId: number): void {
    const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `centro_${  centroId  }.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

}
